import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import { useCallback, useState } from 'react';
import { createResetPasswordOutbound } from '../../api/outbound/commonOutbounds';
import { PasswordRequirementsDetails } from '../../components/passwordRequirementsDetails';
import { WarningMessageContainer } from '../../components/warningMessageContainer';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { setIsResetPasswordPending, setResetPasswordError } from '../../redux/actions/recoverLoginActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { Form } from '../../styles/styles';
const FORM_CSS = css `
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const ResetPasswordForm = ({ uuid, player }) => {
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordConfirmation, setNewPasswordConfirmation] = useState('');
    const dispatch = useAppDispatch();
    const resetPasswordError = useAppSelector((state) => state.recoverLogin.error);
    const isResetPasswordPending = useAppSelector((state) => state.recoverLogin.isResetPasswordPending);
    const socketSend = useSocketSend();
    const onChangeNewPassword = useCallback((event) => {
        setNewPassword(event.target.value);
    }, []);
    const onChangeNewPasswordConfirmation = useCallback((event) => {
        setNewPasswordConfirmation(event.target.value);
    }, []);
    const onSubmit = useCallback((event) => {
        event.preventDefault();
        dispatch(setResetPasswordError(undefined));
        if (!newPassword) {
            dispatch(setResetPasswordError('Enter a new password.'));
            return;
        }
        if (newPassword !== newPasswordConfirmation) {
            dispatch(setResetPasswordError('Password confirmation does not match.'));
            return;
        }
        // client-side checks are OK
        dispatch(setIsResetPasswordPending(true));
        socketSend(createResetPasswordOutbound({ newPassword, uuid, playerId: player.id }));
    }, [dispatch, newPassword, newPasswordConfirmation, player.id, socketSend, uuid]);
    return (_jsxs(_Fragment, { children: [_jsxs("h3", { children: ["Hello ", player.name, "!"] }), _jsx("h3", { children: "Choose a new password to recover access to your account." }), _jsxs(Form, { css: FORM_CSS, onSubmit: onSubmit, children: [_jsx(TextField, { id: 'new-password', type: 'password', variant: 'filled', fullWidth: true, label: 'New Password', value: newPassword, onChange: onChangeNewPassword }), _jsx(TextField, { id: 'new-password-confirmation', type: 'password', variant: 'filled', fullWidth: true, label: 'Confirm New Password', value: newPasswordConfirmation, onChange: onChangeNewPasswordConfirmation }), _jsx(PasswordRequirementsDetails, { isOpen: !!resetPasswordError }), resetPasswordError && _jsx(WarningMessageContainer, { message: resetPasswordError }), _jsx("div", { children: _jsx(Button, { disabled: isResetPasswordPending, variant: 'contained', size: 'large', color: 'secondary', type: 'submit', endIcon: isResetPasswordPending ? _jsx(CircularProgress, { size: 20, color: 'inherit' }) : undefined, children: "Reset Password" }) })] })] }));
};
